import React, { useEffect, useState } from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';

import {
  Button,
  Container,
  NavigationScroll,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
  RecursiveMenu,
} from '@uncinc/react-drupal-core';

import Logo from '../../../assets/images/logo.svg';
import Overlay from './Overlay';
import HamburgerButton from './Hamburger';
import SearchInput from '../../../containers/Search/SearchInput';

import './style.scss';
import { SEARCH_PATH } from '../../../config/constants';

interface MainMenuPros {
  crisisBannerHeight?: number;
}

const MainMenu = React.forwardRef<HTMLDivElement, MainMenuPros>(
  ({ crisisBannerHeight }, ref) => {
    const { t } = useTranslation();
    const [isOverlayOpen, setIsOverlayOpen] = useState<boolean>(false);
    const [isSearchOpen, setIsSearchOpen] = useState<boolean>(false);
    const location = useLocation();

    // block scroll on body if overlay is open
    useEffect(() => {
      if (isOverlayOpen) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }, [isOverlayOpen]);

    const MainMenuClassnames = c(
      'MainMenu',
      { 'overlay-open': isOverlayOpen },
      { 'search-open': isSearchOpen },
    );

    useEffect(() => {
      if (isOverlayOpen) {
        setIsSearchOpen(false);
      }
    }, [isOverlayOpen]);

    useEffect(() => {
      setIsOverlayOpen(false);
      setIsSearchOpen(false);
    }, [location]);

    return (
      <NavigationScroll>
        <div
          style={{ marginTop: crisisBannerHeight, '--crisis-banner-height': `${crisisBannerHeight || 0}px` } as React.CSSProperties}
          className={MainMenuClassnames}
          ref={ref}
        >
          <Overlay
            isOverlayOpen={isOverlayOpen}
            setIsOverlayOpen={setIsOverlayOpen}
          />
          {isSearchOpen && (
          <div className="SearchBarCustom">
            <Container>
              <SearchInput
                setIsSearchOpen={setIsSearchOpen}
              />
            </Container>
          </div>
          )}

          <Container>
            <CoreLink
              href="/"
              className="MainMenu__logo"
              onClick={() => {
                setIsOverlayOpen(false);
                setIsSearchOpen(false);
              }}
            >
              <Image src={Logo} alt="Logo" />
            </CoreLink>

            <div className="MainMenu__links">
              <RecursiveMenu
                navProps={{ 'aria-label': 'Main menu' }}
                menuId="main"
                maxLevel={1}
                additionalClassName="magic-line magic-line--thick"
              />
            </div>

            <div className="MainMenu__buttons">
              <Button
                className="MainMenu__buttons__login Button--secondary icon-after icon-arrow-top-right icon-variant-2"
                href="/leden-login"
              >
                <span>{t('navigation.login')}</span>
              </Button>

              {location.pathname !== SEARCH_PATH && (
                <div className="magic-line magic-line--thick">
                  <Button
                    primary={false}
                    className={`MainMenu__buttons__search Button icon-after ${isSearchOpen ? 'icon-cross' : 'icon-search'}`}
                    onClick={() => setIsSearchOpen((state) => !state)}
                  >
                    <span>{t('navigation.search')}</span>
                  </Button>
                </div>
              )}

              <HamburgerButton
                setIsOverlayOpen={setIsOverlayOpen}
                isOverlayOpen={isOverlayOpen}
              />
            </div>

          </Container>
        </div>
      </NavigationScroll>
    );
  },
);

export default MainMenu;
